import axios from "axios";

const initialState = {
  hasLimitSmsError: false,
  error: false,
  errorMessage: '',
  finishError: false,
  finishErrorMessage: '',
  onboardingFinished: false,
  smsLimitReached: false,
};

export default {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    setLimitSmsError(store) {
      store.hasLimitSmsError = true;
    },
    resetLimitSmsError(store) {
      store.hasLimitSmsError = false;
    },
    setError(store, { hasError, message }) {
      store.error = hasError;
      store.errorMessage = message;
    },
    resetError(store) {
      store.error = false;
      store.errorMessage = ''
    },
    setFinishError(store, { hasError, message }) {
      store.finishError = hasError;
      store.finishErrorMessage = message;
    },
    resetFinishError(store) {
      store.finishError = false;
      store.finishErrorMessage = ''
    },
    setOnboardingInformation(store, payload) {
      const { onboarding_finished, sms_limit_reached } = payload;
      store.onboardingFinished = onboarding_finished;
      store.smsLimitReached = sms_limit_reached;
    },
  },
  actions: {
    async updateOnboardingUses(store, steps) {
      try {
        const options = {
          onboarding_use_options: steps
        };
        await axios.put(`${process.env.VUE_APP_ACCOUNTS_API}/users/onboarding/uses`, options);
      } catch (error) {
        throw error;
      }
    },
    async saveOnboardingSms({commit}, phone) {
      try {
        const params = {
          send_to: phone
        };
        await axios.post(`${process.env.VUE_APP_ACCOUNTS_API}/users/onboarding/sms`, params);
      } catch (error) {
        if(error.status === 429) {
          commit('setLimitSmsError');
        } else {
          commit('setError', {
            hasError: true,
            message: error.data.error,
          });
        }
        throw error;
      }
    },
    async finishOnboarding({ commit }) {
      try {
        await axios.put(`${process.env.VUE_APP_ACCOUNTS_API}/users/onboarding/finish`);
      } catch (error) {
        commit('setFinishError', {
          hasError: true,
          message: 'Unable to complete the onboarding process, please try again or contact support.',
        });
        throw error
      }
    },
    async getUserOnboardingInformation({ commit }) {
      try {
        const resp = await axios.get(`${process.env.VUE_APP_ACCOUNTS_API}/users/onboarding/info`);
        commit('setOnboardingInformation', resp.data);
      } catch (error) {
        commit('setError', {
          hasError: true,
          message: error.data.error,
        });
      }
    },
  },
};
